var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 22,
    viewBox: "0 0 243 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.6L21.2 0.400024H33.8938L12.6938 21.6H0ZM104.514 0.400024L83.3145 21.6H96.0083L117.208 0.400024H104.514ZM125.278 0.400024L104.208 21.6H116.902L137.971 0.400024H125.278ZM145.866 21.6L167.066 0.400024H179.76L158.69 21.6H145.866ZM187.829 0.400024L166.76 21.6H179.454L200.523 0.400024H187.829ZM41.9632 0.400024L20.894 21.6H33.5879L54.657 0.400024H41.9632ZM41.6572 21.6L62.8572 0.400024H75.5511L54.3511 21.6H41.6572ZM83.6204 0.400024L62.5513 21.6H75.2451L96.3142 0.400024H83.6204ZM187.523 21.6L208.723 0.400024H221.417L200.348 21.6H187.523ZM146.041 0.400024L124.972 21.6H137.666L158.866 0.400024H146.041ZM208.417 21.6L229.617 0.400024H242.311L221.242 21.6H208.417Z",
    fill: "url(#paint0_linear_184_14466)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184_14466",
    x1: 242.128,
    y1: 5.89964,
    x2: 33.1947,
    y2: -89.0992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B37BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B37BD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.6686fcb4820d43b60284654d6873cb50.svg";
export { ForwardRef as ReactComponent };